import React from "react";
import styled from "styled-components";

import {
  AdminSection,
  AdminSectionBadge,
  AdminSectionHeader,
} from "../section_engine";


function displayValue(value) {
  if (
    typeof value === "string"
    && value.trim()
  ) {
    return value.trim();
  }

  return "Non renseigné";
}


function formatDate(value) {
  if (
    typeof value !== "string"
    || !value.trim()
  ) {
    return "Non renseigné";
  }

  const normalized =
    value.trim();

  const match =
    normalized.match(
      /^(\d{4})-(\d{2})-(\d{2})$/,
    );

  if (!match) {
    return normalized;
  }

  const [
    ,
    year,
    month,
    day,
  ] = match;

  return `${day}/${month}/${year}`;
}


export default function EmployeeEmploymentSection({
  employment,
}) {
  return (
    <AdminSection
      aria-labelledby={
        "employee-employment-title"
      }
    >
      <AdminSectionHeader>
        <AdminSectionBadge>
          Employment
        </AdminSectionBadge>

        <h2
          id="employee-employment-title"
        >
          Employment
        </h2>

        <p>
          Projection read-only de l'Employment
          courant résolu par le backend.
        </p>
      </AdminSectionHeader>

      {!employment ? (
        <EmptyMessage>
          Aucun Employment courant.
        </EmptyMessage>
      ) : (
        <EmploymentGrid>
          <EmploymentItem>
            <dt>Type de contrat</dt>
            <dd>
              {displayValue(
                employment?.contract_type,
              )}
            </dd>
          </EmploymentItem>

          <EmploymentItem>
            <dt>État</dt>
            <dd>
              {displayValue(
                employment?.state,
              )}
            </dd>
          </EmploymentItem>

          <EmploymentItem>
            <dt>Date de début</dt>
            <dd>
              {formatDate(
                employment?.start_date,
              )}
            </dd>
          </EmploymentItem>

          <EmploymentItem>
            <dt>Date de fin</dt>
            <dd>
              {formatDate(
                employment?.end_date,
              )}
            </dd>
          </EmploymentItem>
        </EmploymentGrid>
      )}
    </AdminSection>
  );
}


const EmptyMessage = styled.p`
  margin: 0;

  color:
    rgba(247, 247, 247, 0.72);
`;


const EmploymentGrid = styled.dl`
  display: grid;

  grid-template-columns:
    repeat(
      auto-fit,
      minmax(190px, 1fr)
    );

  gap: 0.8rem;

  margin: 0;
`;


const EmploymentItem = styled.div`
  min-width: 0;

  padding: 0.75rem;

  border:
    1px solid
    rgba(255, 255, 255, 0.08);

  border-radius: 14px;

  background:
    rgba(11, 19, 40, 0.24);

  dt {
    margin-bottom: 0.35rem;

    color:
      rgba(247, 247, 247, 0.62);

    font-size: 0.76rem;
    font-weight: 700;

    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  dd {
    margin: 0;

    color: #fff9ea;

    font-size: 0.94rem;
    font-weight: 700;

    overflow-wrap: anywhere;
  }
`;
